import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Lookup, LookupOption } from '@/components/ui/lookup';
import { contentApi } from '@/lib/api/endpoints';
import type { ApiContent } from '@/lib/api/types';
interface HubLookupProps {
  value?: LookupOption<ApiContent> | null;
  onChange: (value: LookupOption<ApiContent> | null) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}
export function HubLookup(t0) {
  const $ = _c(19);
  const {
    value,
    onChange,
    placeholder: t1,
    className,
    disabled
  } = t0;
  const placeholder = t1 === undefined ? "Search hubs..." : t1;
  const [searchQuery, setSearchQuery] = useState("");
  let t2;
  if ($[0] !== searchQuery) {
    t2 = {
      queryKey: ["hub-lookup", searchQuery],
      queryFn: async t3 => {
        const {
          pageParam
        } = t3;
        return contentApi.getContent({
          type: "hub",
          status: "published",
          search: searchQuery || undefined,
          limit: 20,
          nextCursor: pageParam || undefined
        });
      },
      getNextPageParam: _temp,
      initialPageParam: "",
      staleTime: 10000
    };
    $[0] = searchQuery;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useInfiniteQuery(t2);
  let t3;
  if ($[2] !== data?.pages) {
    const allResults = data?.pages.flatMap(_temp2) || [];
    t3 = allResults.map(_temp3);
    $[2] = data?.pages;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const options = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = query => {
      setSearchQuery(query);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleSearch = t4;
  let t5;
  if ($[5] !== fetchNextPage || $[6] !== hasNextPage || $[7] !== isFetchingNextPage) {
    t5 = () => {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[5] = fetchNextPage;
    $[6] = hasNextPage;
    $[7] = isFetchingNextPage;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleLoadMore = t5;
  const t6 = isLoading || isFetchingNextPage;
  let t7;
  if ($[9] !== className || $[10] !== disabled || $[11] !== handleLoadMore || $[12] !== hasNextPage || $[13] !== onChange || $[14] !== options || $[15] !== placeholder || $[16] !== t6 || $[17] !== value) {
    t7 = <Lookup value={value} onChange={onChange} onSearch={handleSearch} onLoadMore={handleLoadMore} options={options} isLoading={t6} hasMore={hasNextPage} placeholder={placeholder} emptyMessage="No hubs found" className={className} disabled={disabled} />;
    $[9] = className;
    $[10] = disabled;
    $[11] = handleLoadMore;
    $[12] = hasNextPage;
    $[13] = onChange;
    $[14] = options;
    $[15] = placeholder;
    $[16] = t6;
    $[17] = value;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp3(hub) {
  return {
    id: hub.id,
    label: hub.title || `Hub ${hub.id}`,
    data: hub
  };
}
function _temp2(page) {
  return page.content;
}
function _temp(lastPage) {
  return lastPage.pagination.nextCursor;
}